import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Option, { OPTION_DIRECTION } from './Option';
import * as Styled from './styles';

const RadioList = ({ options, onSelect, direction, margin }) => {
    const [selected, setSelected] = useState(0);

    useEffect(() => {
        onSelect(selected);
    }, [selected, onSelect]);

    return (
        <Styled.RadioListContainer margin={margin}>
            {options.map((option, index) => (
                <Option key={option} direction={direction} text={option} value={selected === index} onSelect={() => setSelected(index)} />
            ))}
        </Styled.RadioListContainer>
    );
};

RadioList.defaultProps = {
    margin: '0',
    direction: OPTION_DIRECTION.LEFT,
};

RadioList.propTypes = {
    options: PropTypes.arrayOf(PropTypes.string).isRequired,
    onSelect: PropTypes.func.isRequired,
    direction: PropTypes.oneOf(Object.values(OPTION_DIRECTION)),
    margin: PropTypes.string,
};

export default RadioList;
